<template>
  <div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="team-list">
        <div class="hd">头像</div>
        <div class="bd">会员信息</div>
        <div class="ft">加入时间</div>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div v-if="RelationStatus == 0">
          <router-link
            :to="'/TeamIndex?MemberId=' + item.MemberID + ''"
            class="team-list"
            v-for="item in dataList"
            :key="item.SerialNumber"
          >
            <div class="hd">
              <div class="avatar">
                <van-image
                  round
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="item.HeadPic"
                />
              </div>
            </div>
            <div class="bd">
              <div class="name">{{ item.NickName }}</div>
              <p class="info-item">
                <span class="label">等级：</span>
                <span class="txt">{{ item.LevelName }}</span>
              </p>
              <!-- <p class="info-item">
              <span class="label">消费金额：</span>
              <span class="txt">100元</span>
              </p>-->
              <p class="info-item">
                <span class="label">一级：</span>
                <span class="txt">{{ item.SubordinateCount }}人</span>
              </p>
              <!-- <p class="info-item">
          <span class="label">共计消费：</span>
          <span class="txt">0元</span>
              </p>-->
            </div>
            <div class="ft">
              <div class="date">{{ item.AddDateTime }}</div>
            </div>
          </router-link>
        </div>
        <div v-else>
          <div
            class="team-list"
            v-for="item in dataList"
            :key="item.SerialNumber"
          >
            <div class="hd">
              <div class="avatar">
                <van-image
                  round
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="item.HeadPic"
                />
              </div>
            </div>
            <div class="bd">
              <div class="name">{{ item.NickName }}</div>
              <p class="info-item">
                <span class="label">等级：</span>
                <span class="txt">{{ item.LevelName }}</span>
              </p>
              <!-- <p class="info-item">
              <span class="label">消费金额：</span>
              <span class="txt">100元</span>
              </p>-->
              <p class="info-item">
                <span class="label">一级：</span>
                <span class="txt">{{ item.SubordinateCount }}人</span>
              </p>
              <!-- <p class="info-item">
          <span class="label">共计消费：</span>
          <span class="txt">0元</span>
              </p>-->
            </div>
            <div class="ft">
              <div class="date">{{ item.AddDateTime }}</div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: [],
    };
  },
  props: {
    RelationStatus: 0,
  },
  mounted() {},
  computed: {},
  methods: {
    init() {
      var that = this;
      that.options = {
        type: "MemberRelationLevelSearch",
        pageIndex: 1,
        relationStatus: that.RelationStatus,
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1,
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1,
      });
      this.getList();
    },
    getList() {
      var that = this;
      that.$store.dispatch(this.options).then(
        (res) => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.MemberRelationLevelApiModelList != null) {
            if (res.MemberRelationLevelApiModelList.length <= 0) {
              that.finished = true;
            }
            if (this.options.pageIndex > 1) {
              if (res.MemberRelationLevelApiModelList.length > 0) {
                res.MemberRelationLevelApiModelList.forEach((element) => {
                  that.dataList.push(element);
                });
              }
            } else {
              that.dataList = res.MemberRelationLevelApiModelList;
            }
          } else {
            that.finished = true;
          }
        },
        (error) => {}
      );
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
.team-list {
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #eee;
  padding: 14px;
}
.team-list > .hd,
.team-list > .bd,
.team-list > .ft {
  font-size: 13px;
}
.team-list > .hd {
  width: 60px;
  margin-right: 15px;
}
.team-list > .hd .avatar {
  width: 60px;
  height: 60px;
}
.team-list > .bd {
  flex: 1;
  overflow: hidden;
}
.team-list > .bd .name {
  font-size: 16px;
  margin-bottom: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.team-list > .bd .info-item {
  font-size: 13px;
}
.team-list > .bd .info-item .label {
  color: #888;
}
.team-list > .bd .info-item .txt {
  color: #444;
}
.team-list > .ft {
  margin-left: 12px;
  width: 80px;
  text-align: right;
}
.team-list > .ft .date {
  font-size: 12px;
  color: #999;
}
</style>